import React,{useState, useEffect} from 'react'
import {Link} from 'react-router-dom'
import { auth, db } from './firebase'
import Friend from './friend'
import './styles/friends.css'
import {Redirect} from 'react-router-dom'

export default function Friends() {
    const [loading,setLoading]=useState(false)
    const [loggedIn, setLoggedIn]=useState(true)
    const [userId,setUserId]=useState(null)
    const [friends,setFriends]=useState([])
    let listedFriends=[]

    //============================================================
    //
    //getting the user info as soon as the app runs
    //
    //============================================================ 
    const userInfo=()=>{
        setLoading(true)
        setLoggedIn(true)
        auth.onAuthStateChanged(user=>{
        if(user){
            setUserId(user.email)
            //  Getting friends from my database
            db.collection(user.email).doc('data').collection('friends').get()
            .then(data=>{
                data.docs.forEach(a=>{
                    //console.log(a.data())
                    listedFriends.push(a.data())

                }
                )
            }).then(()=>{ setFriends(listedFriends)})
            .then(()=>{
                setLoading(false)
                
            })
            
        }else{
            alert ('Please Login first')
            setLoggedIn(false)
        }
        })
    }
    useEffect(()=>{
         userInfo()
    },[])

    //============================================================
    //
    //  Adding friends
    //
    //============================================================
    const addFriend=()=>{
        let friendName=document.querySelector("#friend-name").value
        db.collection(userId).doc('data').collection('friends').doc(friendName).set({
            handle:friendName
        })
        userInfo()
    }

    //============================================================
    //
    
    //
    //============================================================

    
    
    //===================================================================
    //
    //toggling the bar
    //
    //===================================================================
    const openDrawer=()=>{
        const drawer=document.querySelector('.drawer')
        drawer.classList.toggle('open-drawer')
        //console.log('done')
    }
    //console.log(listedFriends)
    //===================================================================
    //
    //  Creating The loading Screen
    //
    //===================================================================
    if (loading){
        return(
            <div className="loading-screen">
            <i class="material-icons loading"> hourglass_empty</i>
            <p>Loading......</p>
            </div>
        );
    }
    if(!loggedIn){
        return(<Redirect to='/'/>)
    }
    else{
        return (
        <div>
            <div className="navbar">
                <h3>Codeforces tracked</h3>
                <i class="material-icons md-64" onClick={openDrawer}>menu</i>
                <ul class='drawer'>
                    <Link to='/home' style={{textDecoration:'none', color:'black'}}><li>My Account</li></Link>
                    <Link to='/problems'style={{textDecoration:'none', color:'black'}}><li>Saved Problems</li></Link>
                    <Link to='/submissions' style={{textDecoration:'none', color:'black'}}><li>Submissions</li></Link>
                    <Link to='/friends' style={{textDecoration:'none', color:'black'}}><li>Track friends</li></Link>
                    <li>Upcoming</li>
                    <li onClick={()=>auth.signOut()}>Log Out</li>
                </ul>
            </div>
            <div className="title">
                <h1>Friends</h1>
                <p>Lets you add friends and see what they're up to </p>
            </div>
            <div className="inputs">
                
                <input type="text" id='friend-name' placeholder="Friend's handle" />
                <i class="material-icons" id='add' onClick={addFriend} >add_box</i>
            
            </div>

            <div className="main-container">
                {friends.map(a=>(
                    <Friend handle={a.handle} key={a.handle}/>
                ))}
                
            </div>
            
        </div>
    )


    }

}
